// extracted by mini-css-extract-plugin
var _1 = "Popover-x9E9Y";
var _2 = "slideInPopover-XfJH6";
export { _1 as "Popover", _2 as "slideInPopover" }
